// src/constants/internalKeys.js

const INTERNAL_KEYS = {
    // Part-related fields
    'customer_mpn': 'customer_mpn',
    'supplier_mpn': 'supplier_mpn',
    'customer_mfr': 'customer_mfr',
    'supplier_mfr': 'supplier_mfr',
    'ipn': 'ipn', // Customer Internal Part Number 
    'date_code': 'date_code',
    'supplier_price': 'supplier_price',
    'customer_target': 'customer_target',
    'supplier_qty': 'supplier_qty', // This is the quantity the supplier can provide (available qty)
    'demand_qty': 'demand_qty',
    'quote_qty': 'quote_qty', // Quoted qty not relevant unitl VQ stage
    'spq': 'spq',
    'in_stock': 'in_stock',
    'lead_time': 'lead_time',
    'due_date': 'due_date',

    // Supplier-related Fields
    'supplier_name': 'supplier_name',
    'supplier_location': 'supplier_location',
    'supplier_contact': 'supplier_contact',
    'supplier_email': 'supplier_email',
    'supplier_rating': 'supplier_rating',
    'sup_info_date': 'sup_info_date',
    
    // Customer-related Fields
    'customer_name': 'customer_name',
    'customer_location': 'customer_location',
    'customer_contact': 'customer_contact',
    'customer_email': 'customer_email',
    'req_date': 'req_date',
    'req_number': 'req_number',


    // Additional Fields
    'total_opportunity': 'total_opportunity',
    'profit_potential': 'profit_potential',
    'supplier_source': 'supplier_source',
    'notes': 'notes'
};

export default INTERNAL_KEYS;
